import api from '../api';
import {store} from '../store';

let apiUrl = 'cart-products';

const state = {
    data: {},
    meta: {}
};

const actions = {
    // cart_products.js (Ausschnitt)
    store: async ({commit}, data) => {
        await store.dispatch('cart/getCart');

        return api.post(`/api/v1/${apiUrl}`, data).then((response) => {
            commit('set', response.data);

            try {
                const cartItems = response?.data?.data?.cartProducts?.data || [];
                const added =
                    cartItems.find(cp => cp?.productVariant?.id === data?.product_variant_id) ||
                    cartItems[cartItems.length - 1];

                if (added) {
                    const pv = added.productVariant;
                    const p = added.product;
                    const ga = data?.__ga || {};

                    // Name & Kategorie (aus __ga -> API -> Fallback)
                    const item_name =
                        ga.product_name ||
                        p?.name?.de || p?.name || 'Produkt';

                    const item_category =
                        ga.category_name ||
                        p?.productCategories?.data?.[0]?.name?.de ||
                        p?.productCategories?.data?.[0]?.name ||
                        'Kategorie';

                    // Variante (z. B. "1 Monat"), item_id = VARIANTEN-ID (gewünscht)
                    const pavPeriod = pv?.productAttributeValues?.data?.find(av => av?.meta?.type === 'period');
                    const variantTitle = (pavPeriod?.title?.de ?? pavPeriod?.title ?? 'Variante').toString();
                    const item_id = pv?.id; // <— nur Varianten-ID

                    // Preis & Währung
                    const price = Number(pv?.total_end_price_gross ?? pv?.base_price_gross ?? 0);
                    const currency = ga.currency || 'EUR';

                    const item = {
                        item_id,
                        item_name,
                        item_category,
                        item_variant: variantTitle,
                        price,
                        currency,
                        quantity: 1,
                        index: 0
                    };

                    // ecommerce-Objekt ohne undefined-Keys aufbauen
                    const ecommerce = {
                        ...(ga.item_list_name ? {item_list_name: ga.item_list_name} : {}),
                        currency,
                        value: price,
                        items: [item]
                    };

                    window.dataLayer = window.dataLayer || [];
                    window.dataLayer.push({ecommerce: null});
                    window.dataLayer.push({
                        event: 'add_to_cart',
                        ecommerce
                    });
                }
            } catch (e) {
                console.warn('GA4 add_to_cart build failed', e);
            }

            return response.data;
        }).catch((error) => {
            console.error(error);
            return Promise.reject(error);
        });
    },


    delete: async ({commit}, data) => {
        await store.dispatch('cart/getCart');

        return api
            .delete(`/api/v1/${apiUrl}/${data.id}`, data)
            .then((response) => {
                store.commit('cart/set', response.data);
                commit('set', response.data);

                window.dataLayer = window.dataLayer || [];
                window.dataLayer.push({ecommerce: null});
                (function () {
                    const p = data.product;
                    const pv = data.productVariant;
                    const pavPeriod = pv?.productAttributeValues?.data?.find(av => av?.meta?.type === 'period');
                    const variantTitle = pavPeriod?.title?.de ?? pavPeriod?.title ?? 'Variante';
                    const slug =
                        p?.slug?.name ??
                        (p?.name?.de || p?.name || String(p?.id || 'product'))
                            .toString().toLowerCase().replace(/\s+/g, '-').replace(/[^a-z0-9\-]/g, '');
                    const variantSlug =
                        variantTitle.toString().toLowerCase().replace(/\s+/g, '-').replace(/[^a-z0-9\-]/g, '');
                    const item_id = `${slug}-${variantSlug}`;
                    const price = Number(pv?.total_end_price_gross ?? pv?.base_price_gross ?? 0);
                    const currency = 'EUR';
                    const item = {
                        item_id,
                        item_name: p?.name?.de ?? p?.name ?? 'Produkt',
                        item_category: p?.productCategories?.data?.[0]?.name?.de ?? p?.productCategories?.data?.[0]?.name ?? 'Kategorie',
                        item_variant: variantTitle,
                        price,
                        currency,
                        quantity: 1,
                        index: 0
                    };
                    window.dataLayer.push({
                        event: 'remove_from_cart',
                        ecommerce: {
                            currency,
                            value: price,
                            items: [item]
                        }
                    });
                })();

                sessionStorage.removeItem('auto-applied-coupon');

                return response.data;
            })
            .catch((error) => {
                console.error(error);
                return Promise.reject(error);
            });
    }
};

const mutations = {
    set(state, data) {
        state.data = data.data;
        state.meta = data.meta;
    },
    setMeta(state, data) {
        state.meta = data.data;
    },
    setData(state, data) {
        state.data = data.meta;
    },
    clear(state, data) {
        state.data = {};
        state.meta = {};
    }
};

const getters = {
    get: (state) => {
        return state.data;
    },
    getMeta: (state) => {
        return state.meta;
    },
    getData: (state) => {
        return state.data;
    }
};

export default {
    namespaced: true,
    state,
    actions,
    getters,
    mutations
};
